var render = function render(){var _vm=this,_c=_vm._self._c;return _c('oiliness-template',{attrs:{"has-greasy-skin":_vm.hasGreasySkin,"greasy-skin":_vm.greasySkin,"open-facial-pores":_vm.openFacialPores,"excess-shine":_vm.excessShine,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }